import { NavBar } from "@finanedi.es/storybook"
import { TurboTable } from "@legacy/@bit/gedesco.reactcomponentsgdc.turbo-table/dist/TurboTable"
import Modal from "common/components/Modal/Modal"
import NavBarChildren from "common/components/NavBar"
import useFetchTurboTable from "common/hooks/useFetchTurboTable"
import FacturaService from "common/services/FacturaService"
import { formatDocumentoName } from "common/utils/formats"
import DownloadDocumentoModal from "features/Documentos/components/DocumentosActions/modals/DownloadDocumentoModal"
import Welcome from "features/Documentos/components/Welcome/Welcome"
import { TIPOS_DOCUMENTO } from "features/Documentos/constants"
import {
  documentosSelector,
  hideDownloadDocumentoModal,
} from "features/Documentos/redux/documentosSlice"
import { logout, userSelector } from "features/User/redux/slices/userSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { noop } from "lodash"
import { useCallback, useEffect, useMemo, useState } from "react"
import { Redirect } from "react-router-dom"
import { columns } from "./columns"

const MyFacturasAsLibrado = ({ history }: $TSMigrationFixMe) => {
  const { logged } = useSelector(userSelector)
  const { selectedDocumento, isDownloadDocumentoModalShowing } =
    useSelector(documentosSelector)
  const [showModal, setShowModal] = useState(!logged)
  const [razonSocialEmisor, setRazonSocialEmisor] = useState("")
  const [msgEncrypted, setMsgEncrypted] = useState(null)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(logout())
  }, [dispatch])

  useEffect(() => {
    if (history?.location?.pathname) {
      const msg = history?.location?.pathname?.replace?.("/misfacturas/", "")
      setMsgEncrypted(msg)
    }
  }, [history])

  const mapItems = useCallback((res: $TSMigrationFixMe) => {
    setRazonSocialEmisor(res?.data?.items[0]?.razonSocial)
    return res?.data?.items?.map((factura: $TSMigrationFixMe) => ({
      serie: factura.serie,
      fechaEmision: factura.fechaEmision,
      importe: factura.importe,
      numero: factura.numero,
      id: factura.id,
      cliente: factura.usuario?.razonSocial,
      razonSocial: factura.usuario?.razonSocial,
      divisa: factura.divisa,
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
      tipo: TIPOS_DOCUMENTO[factura.tipoDocumentoComercial],
    }))
  }, [])

  const handleCloseDownloadDocumentoModal = () => {
    dispatch(hideDownloadDocumentoModal())
  }

  // @ts-expect-error TS(7030): Not all code paths return a value.
  const fileName = useMemo(() => {
    if (isDownloadDocumentoModalShowing && selectedDocumento) {
      return formatDocumentoName({
        documentoType: "factura",
        numero: selectedDocumento.numero,
        serie: selectedDocumento.serie,
        razonSocial: selectedDocumento.razonSocial,
        isDocumentoRecibido: selectedDocumento.isDocumentoRecibido,
      })
    }
  }, [isDownloadDocumentoModalShowing, selectedDocumento])

  const fetchItems = useCallback(() => {
    if (!msgEncrypted) {
      return noop
    }

    return (queryState: $TSMigrationFixMe) => {
      return FacturaService.getFacturaByMsgEncrypted({
        msgEncrypted,
        queryState,
      })
    }
  }, [msgEncrypted])

  const { totalCount, items, isLoading, setQueryState, isError } =
    useFetchTurboTable({
      mapItems,
      fetchItems,
    })

  if (isError) return <Redirect to='/' />

  return (
    <>
      <NavBar classNameNavBar='!tw-w-full !tw-flex-grow-0 tw-shadow-md tw-min-h-5 tw-h-16 tw-flex tw-items-center tw-p-0.5 tw-z-0 tw-bg-primary tw-order-last'>
        <NavBarChildren
          secondary
          hideRegis={false}
        />
      </NavBar>

      <div className='h-auto dashboard-container'>
        <div className='content-container d-flex justify-content-center'>
          {!showModal && (
            <div className='col-xl-7'>
              <h5 className='pb-3 text-left'>
                Facturas de {razonSocialEmisor}
              </h5>

              <TurboTable
                columns={columns}
                value={items}
                totalRecords={totalCount}
                isLoading={isLoading}
                setQueryState={setQueryState}
                showFilter={false}
                paginator
                showSelectColumns={false}
                showHeader={false}
              />
            </div>
          )}
        </div>

        <Modal
          style={{ maxWidth: "528px" }}
          onHide={noop}
          visible={showModal}
          closable={false}
        >
          <Welcome onHide={() => setShowModal((prev) => !prev)} />
        </Modal>

        <DownloadDocumentoModal
          onHide={handleCloseDownloadDocumentoModal}
          title='factura'
          visible={isDownloadDocumentoModalShowing}
          downloadPdf={FacturaService.getPdfById}
          id={selectedDocumento?.id}
          fileName={fileName}
        />
      </div>
    </>
  )
}

export default MyFacturasAsLibrado
